import { render, staticRenderFns } from "./ProfessionalPersonalData.vue?vue&type=template&id=64bf4880&scoped=true"
import script from "./ProfessionalPersonalData.vue?vue&type=script&lang=js"
export * from "./ProfessionalPersonalData.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalPersonalData.vue?vue&type=style&index=0&id=64bf4880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf4880",
  null
  
)

export default component.exports